<template>
  <div id="nav-indicator" class="nav-indicator-container">
    <div ref="progress-nav" class="progress-nav"></div>
  </div>
  
</template>

<script>
  export default {
    name: 'Navbar',
    mounted() {
      window.addEventListener('scroll', () => {
        this.navProgress()
      })
    },
    methods: {
      navProgress() {
        const long = document.querySelector('#app').offsetHeight + document.querySelector('#app').offsetTop
        const percent = (window.scrollY / long ) * 100
        console.log(long)
        this.$refs['progress-nav'].style.width = `${percent}%`
      }
    }
  }   
</script>

<style lang="scss">

  .nav-indicator-container {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    z-index: 99;
    background: #e3e3e3;
    transition: bottom .25s ease-in-out;

    .progress-nav {
      background-color: var(--app-yellow);
      height: 25px;
      width: 0%;
    }
  }

</style>